exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:365px){.time-format-label[data-v-2be7dcb2]{font-size:1.1REM}}", ""]);

// exports
